// extracted by mini-css-extract-plugin
module.exports = {"titleAndDescription":"styles_titleAndDescription__le1kv","title":"styles_title__gbNM5","title__order":"styles_title__order__7L6Vy","description":"styles_description__J_Vrj"};